"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeFirebaseError = void 0;
var general_1 = require("./general");
var messages_1 = require("../api/calls/user/authentication/constants/messages");
var decodeFirebaseError = function (error) {
    if ((0, general_1.objectIsEmpty)(error)) {
        return "An unexpected error occurred. Please try again.";
    }
    switch (error.code) {
        case messages_1.USER_NOT_FOUND:
            return "No user found with this email address.";
        case messages_1.INCORRECT_PASSWORD:
            return "Incorrect password. Please try again.";
        case messages_1.INVALID_EMAIL:
            return "Invalid email address format.";
        case messages_1.TOO_MANY_REQUESTS:
            return "Too many login attempts. Please try again later.";
        case messages_1.EMAIL_ALREADY_IN_USE:
            return "This email address is already in use. Please try a different one.";
        case messages_1.WEAK_PASSWORD:
            return "The password is too weak. Please choose a stronger password.";
        case messages_1.OPERATION_NOT_ALLOWED:
            return "This operation is not allowed. Please contact support.";
        case messages_1.EXPIRED_ACTION_CODE:
            return "The action code has expired. Please request a new one.";
        case messages_1.INVALID_ACTION_CODE:
            return "The action code is invalid. Please check the link and try again.";
        case messages_1.INVALID_VERIFICATION_CODE:
            return "The verification code is invalid. Please check the code and try again.";
        case messages_1.INVALID_CREDENTIAL:
            return "The provided credential is invalid. Please check your input and try again.";
        case messages_1.INVALID_LOGIN_CREDENTIALS:
            return "Invalid login credentials. Please check your email and password.";
        case messages_1.PASSWORD_DOES_NOT_MEET_REQUIREMENTS:
            return "The password does not meet the requirements. Please choose a different password.";
        case messages_1.USER_DISABLED:
            return "This account has been disabled. Please contact support.";
        case messages_1.MISSING_EMAIL:
            return "Please enter your email address.";
        case messages_1.NETWORK_REQUEST_FAILED:
            return "We could not connect. Please check your internet connection and try again.";
        default:
            console.error("Unexpected Firebase error:", error);
            return "An unexpected error occurred. Please try again.";
    }
};
exports.decodeFirebaseError = decodeFirebaseError;
